// src/components/EventMap.js

import React, { useEffect, useRef, useMemo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const EventMap = ({ lat, lng, maxHeight = '300px', mobileHeight = '200px', borderRadius = '0px', padding = '0px', margin = '0px' }) => {
  const mapRef = useRef(null);
  const mapContainerRef = useRef(null);
  const markerRef = useRef(null);

  // Memorizar el objeto 'center' para evitar re-renderizados innecesarios
  const center = useMemo(() => ({ lat, lng }), [lat, lng]);

  // Inicializar el mapa (sólo una vez)
  // useEffect(() => {
  //   if (!window.google || !window.google.maps) {
  //     console.error('Google Maps API no está disponible.');
  //     return;
  //   }
  //   if (!mapRef.current) {
  //     mapRef.current = new window.google.maps.Map(mapContainerRef.current, {
  //       // center: center,
  //       center: { lat, lng },
  //       zoom: 16,
  //       disableDefaultUI: true,
  //       zoomControl: true,
  //       scrollwheel: false,
  //       draggable: true,
  //       disableDoubleClickZoom: true,
  //       mapTypeControl: false,
  //       fullscreenControl: false,
  //       streetViewControl: false,
  //       mapId: 'f29e19ef0914499b', // Reemplaza con tu Map ID
  //     });
  //   }
  // }, []); // Se ejecuta una sola vez al montar

  useEffect(() => {
    if (!window.google || !window.google.maps) {
      console.error('Google Maps API no está disponible.');
      return;
    }
    if (!mapRef.current) {
      mapRef.current = new window.google.maps.Map(mapContainerRef.current, {
        center: { lat, lng }, // Usamos directamente lat y lng
        zoom: 16,
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: false,
        draggable: true,
        disableDoubleClickZoom: true,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        mapId: 'f29e19ef0914499b',
      });
    }
  }, [lat, lng]);

  // Cada vez que cambien las coordenadas (center), actualizamos el mapa y recreamos el marcador
  // useEffect(() => {
  //   if (!mapRef.current || !window.google || !window.google.maps) return;

  //   // Actualizamos el centro del mapa
  //   mapRef.current.setCenter(center);

  //   // Si existe un marcador previo, lo removemos
  //   if (markerRef.current) {
  //     markerRef.current.map = null;
  //     markerRef.current = null;
  //   }

  //   // Creamos el nuevo marcador
  //   const svgIconUrl = '/icons/map-pin-motorik.svg'; // Ruta al SVG de tu marcador
  //   fetch(svgIconUrl)
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error('Error en la respuesta de red');
  //       }
  //       return response.text();
  //     })
  //     .then((svgText) => {
  //       const markerDiv = document.createElement('div');
  //       markerDiv.innerHTML = svgText;
  //       const svgElement = markerDiv.querySelector('svg');
  //       if (svgElement) {
  //         svgElement.style.width = '100%';
  //         svgElement.style.height = '100%';
  //         svgElement.style.display = 'block';
  //       }
  //       // Definimos el tamaño y estilo del contenedor del marker
  //       markerDiv.style.width = '28px';
  //       markerDiv.style.height = '28px';
  //       markerDiv.style.display = 'flex';
  //       markerDiv.style.alignItems = 'center';
  //       markerDiv.style.justifyContent = 'center';
  //       markerDiv.style.cursor = 'pointer';

  //       markerRef.current = new window.google.maps.marker.AdvancedMarkerElement({
  //         map: mapRef.current,
  //         position: center,
  //         content: markerDiv,
  //       });
  //     })
  //     .catch((error) => {
  //       console.error('Error al obtener el SVG:', error);
  //     });
  // }, [center]);

  // // Limpiar el marcador al desmontar el componente
  // useEffect(() => {
  //   return () => {
  //     if (markerRef.current) {
  //       markerRef.current.map = null;
  //       markerRef.current = null;
  //     }
  //   };
  // }, []);

  useEffect(() => {
    if (!mapRef.current || !window.google || !window.google.maps) return;

    mapRef.current.setCenter(center);

    if (markerRef.current) {
      markerRef.current.map = null;
      markerRef.current = null;
    }

    const svgIconUrl = '/icons/map-pin-motorik.svg';
    fetch(svgIconUrl)
      .then((res) => {
        if (!res.ok) throw new Error('Error al cargar el SVG');
        return res.text();
      })
      .then((svgText) => {
        const markerDiv = document.createElement('div');
        markerDiv.innerHTML = svgText;

        const svgElement = markerDiv.querySelector('svg');
        if (svgElement) {
          svgElement.style.width = '100%';
          svgElement.style.height = '100%';
          svgElement.style.display = 'block';
        }

        markerDiv.style.width = '28px';
        markerDiv.style.height = '28px';
        markerDiv.style.display = 'flex';
        markerDiv.style.alignItems = 'center';
        markerDiv.style.justifyContent = 'center';
        markerDiv.style.cursor = 'pointer';

        markerRef.current = new window.google.maps.marker.AdvancedMarkerElement({
          map: mapRef.current,
          position: center,
          content: markerDiv,
        });
      })
      .catch((err) => {
        console.error('Error al obtener el SVG:', err);
      });
  }, [center]);

  useEffect(() => {
    return () => {
      if (markerRef.current) {
        markerRef.current.map = null;
        markerRef.current = null;
      }
    };
  }, []);


  return (
    <MapContainer
      $maxHeight={maxHeight}
      $mobileHeight={mobileHeight}
      $padding={padding}
      $margin={margin}
    >
      <Map
        ref={mapContainerRef}
        style={{ width: '100%', height: '100%' }}
        $borderRadius={borderRadius}
      />
    </MapContainer>
  );
};

// Definir tipos de props
EventMap.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  maxHeight: PropTypes.string, // Prop para altura máxima
  mobileHeight: PropTypes.string, // Prop para altura en pantallas pequeñas
};

export default EventMap;

// Definir el Styled Component usando props transitorios ($)
const MapContainer = styled.div`
  width: 100%;
  height: ${(props) => props.$maxHeight}; /* Altura configurable */
  // border-radius: ${(props) => props.$borderRadius};
  overflow: hidden;
  margin: ${(props) => props.$margin}; /* Margin configurable */
  padding: ${(props) => props.$padding}; /* Padding configurable */
  @media (max-width: 768px) {
    height: ${(props) => props.$mobileHeight}; /* Altura para pantallas pequeñas */
  }
`;

const Map = styled.div`
  width: 100%;
  height: 100%;
  // margin: ${(props) => props.$margin}; 
  // padding: ${(props) => props.$padding}; 
  border-radius: ${(props) => props.$borderRadius};
  overflow: hidden;
`;

